import { SearchConstants } from './search.constants'
import { ISearchState } from './search.types'

export const initialSearchState: ISearchState = {
  isLoading: false,
  searchText: '',
  options: [],
  filteredOptions: [],
  currentOptions: [],
}

export function searchReducer(state: ISearchState = initialSearchState, action: any): ISearchState {
  switch (action.type) {
    case SearchConstants.SET_SEARCH_TEXT:
      return { ...state, searchText: action.searchText }
    case SearchConstants.SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading }
    case SearchConstants.INITIALIZE_SEARCH:
      return { ...state, options: action.options, filteredOptions: action.options, searchText: '', isLoading: false }
    case SearchConstants.SET_FILTERED_OPTIONS:
      return {
        ...state,
        filteredOptions: action.filteredOptions,
        currentOptions: action.filteredOptions,
        isLoading: false,
      }
    case SearchConstants.CURRENT_OPTIONS:
      return { ...state, currentOptions: action.currentOptions, isLoading: false }
    case SearchConstants.RESET_STATE:
      return { ...initialSearchState }
    default:
      return state
  }
}
